import useSWRMutation from 'swr/mutation';
import {PaginatedRequest} from 'utils/types/store';
import letrusAPI from '../axiosInstance';
import {CompositionCompetence} from './types';

export function fetchCompositionCompetence() {
  return useSWRMutation<
    PaginatedRequest<CompositionCompetence[]>,
    Error,
    string,
    number | string
  >(
    '/api/v1/composition_competence',
    async (url, {arg: id}) => {
      const response = await letrusAPI(`${url}?review_grid=${id}&minimal=1`, {
        method: 'get',
      });

      return response.data;
    },
    {throwOnError: false},
  );
}
